import React, { useEffect, useState } from "react";
import { api } from "../api";
import { DashboardStats } from "../types";
import { Spinner } from "../common/ui";

export function AdminDashboard({ onOpenCases }: { onOpenCases: () => void }) {
  const [stats, setStats] = useState<DashboardStats | null>(null);

  useEffect(() => {
    api.dashboard().then(setStats);
  }, []);

  if (!stats) return <Spinner />;

  const cards: { label: string; value: number }[] = [
    { label: "کل پرونده‌ها", value: stats.total },
    { label: "جدید امروز", value: stats.newToday },
    { label: "ناقص", value: stats.incomplete },
    { label: "آماده بررسی", value: stats.readyForReview },
    { label: "در حال بررسی", value: stats.underReview },
    { label: "آماده ارسال به بانک", value: stats.readyForBank },
    { label: "ارسال شده به بانک", value: stats.sentToBank },
  ];

  return (
    <div>
      <h2>داشبورد</h2>
      <div className="stat-grid">
        {cards.map((c) => (
          <div className="stat-card" key={c.label}>
            <div className="value">{c.value}</div>
            <div className="label">{c.label}</div>
          </div>
        ))}
      </div>
      <button className="btn btn-primary" style={{ width: "auto" }} onClick={onOpenCases}>مشاهده همه پرونده‌ها</button>
    </div>
  );
}
